import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { checkUserPermission } from "../../common/UserPermission";



const ItemsDetailsModal = ({ id }) => {
  
  const [toggleItemsPrice, setToggleItemsPrice] = useState(false);
  const [itemsDetailsData, setItemsDetailsData] = useState();

  
  const token = localStorage.getItem("Token");
  // const bk = "http://localhost:3011/api/v1/"
  // const bk = "https://api-items.sonarpos.com/api/v1/"

  useEffect(() => {
    if (id > 0) {
      axios
        .get(`${config.itemsBaseUrl}/items/detailsbinding?itemid=${id}`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          // this.setState({ data: res.data.ResponseData });
          if (res.data?.ResponseData != undefined) {
            if (id > 0) {
              setItemsDetailsData(res.data.ResponseData);
            }
          }
          // console.log("Show POPUP data =>", res.data.ResponseData)
        });
    }
  }, [id]);

  const getListByInventoryID = itemsDetailsData?.Inventory.filter(
    (item) => item.LocationId === 45
  );
  
  return (
    <>
      <div
        className="modal fade"
        id="ItemsDetailsModal"
        tabIndex={-1}
        // data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {itemsDetailsData?.ItemInfo[0].Name} [ID:{" "}
                {itemsDetailsData?.ItemInfo[0].ID}]{" "}
              </h4>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <ul className="nav nav-tabs">
                    <li className="nav-item fs-5">
                      <a
                        className="nav-link active"
                        href="#ItemsDetailsTab1"
                        data-bs-toggle="tab"
                      >
                        Item Info
                      </a>
                    </li>
                    <li className="nav-item fs-5">
                      <a
                        className="nav-link"
                        href="#ItemsDetailsTab2"
                        data-bs-toggle="tab"
                      >
                        Pricing
                      </a>
                    </li>
                    <li className="nav-item fs-5">
                      <a
                        className="nav-link"
                        href="#ItemsDetailsTab3"
                        data-bs-toggle="tab"
                      >
                        Inventory
                      </a>
                    </li>
                    <li className="nav-item fs-5">
                      <a
                        className="nav-link"
                        href="#ItemsDetailsTab4"
                        data-bs-toggle="tab"
                      >
                        Images
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div className="tab-pane show active" id="ItemsDetailsTab1">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <h4>
                                      <i
                                        class="fa fa-info-circle  fa-lg"
                                        aria-hidden="true"
                                      ></i>
                                      Item Information
                                    </h4>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Category</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].Category}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Description</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].Description}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Item Id</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].ID}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Product ID</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].ProductID}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Allow Alt Description
                                  </td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0]
                                      .Allowaltdescription == 1
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Item has Serial Number
                                  </td>
                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0]
                                      .IsItemserialnumber == 1
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Generate Barcodes
                                  </td>
                                  <td className="col-md-9">
                                    {" "}
                                    <a href="/customer-barcode-label/">
                                      Print
                                    </a>{" "}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <h4>
                                      <i
                                        class="fa fa-th-list"
                                        aria-hidden="true"
                                      ></i>
                                      Item Variations
                                    </h4>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-1"></td>
                                  <td className="col-md-3">Name</td>
                                  <td className="col-md-3">Attributes</td>
                                  <td className="col-md-3">Supplier</td>
                                </tr>
                                {itemsDetailsData?.ItemVariations.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                        <img
                                          src={items.ImageName}
                                          onError={(e) => {
                                          e.currentTarget.src =
                                         "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                                          }}
                  // alt={props.Name}
                                        className="img-thumbnail  mr-5"
                                        width="45"
                                        height="45"
                                         />
                                        </td>
                                        <td className="col-md-3">
                                          {items?.Name}
                                        </td>
                                        <td className="col-md-3">
                                          {items?.Attribute}
                                        </td>
                                        <td className="col-md-3">
                                          {items?.Supplier}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab2">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <h4>
                                      <i
                                        class="fa fa-money"
                                        aria-hidden="true"
                                      ></i>
                                      Pricing
                                    </h4>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Selling Price</td>
                                  <td className="col-md-3">
                                    {Number(
                                      itemsDetailsData?.ItemInfo[0].Unitprice
                                    ).toFixed(2)}
                                  </td>
                                  <td className="col-md-3"></td>
                                </tr>
                                {checkUserPermission('show-cost-price') &&
                                <tr>
                                  <td className="col-md-3">Cost Price</td>
                                  <td className="col-md-3">
                                    {toggleItemsPrice &&
                                      Number(
                                        itemsDetailsData?.ItemInfo[0].Costprice
                                      ).toFixed(2)}
                                    <Link
                                      type="button"
                                      className="btn btn-sm btn-outline-dark m-1"
                                      onClick={() =>
                                        setToggleItemsPrice(!toggleItemsPrice)
                                      }
                                    >
                                      {!toggleItemsPrice ? (
                                        <>
                                          <i className="fa fa-plus"></i>{" "}
                                        </>
                                      ) : (
                                        <>
                                          <i className="fa fa-minus"></i>{" "}
                                        </>
                                      )}
                                    </Link>
                                  </td>
                                  <td className="col-md-3"></td>
                                </tr>
                                 }
                                <tr>
                                  <th className="col-md-3">Variation</th>
                                  <th className="col-md-3">Selling Price</th>
                                  {checkUserPermission('show-cost-price') &&
                                  <th className="col-md-3">Cost Price</th>
                                  }
                                </tr>
                                {itemsDetailsData?.Pricing.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-3">
                                          {items?.Name}
                                        </td>
                                        <td className="col-md-3">
                                          {Number(items?.SellingPrice).toFixed(
                                            2
                                          )}
                                        </td>
                                        {checkUserPermission('show-cost-price') &&
                                        <td className="col-md-3">
                                          {Number(items?.CostPrice).toFixed(2)}
                                        </td>
                                        }
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab3">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <h4>
                                      <i
                                        class="fa fa-list-ul"
                                        aria-hidden="true"
                                      ></i>
                                      Inventory
                                    </h4>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                               
                                        <tr>
                                          <td className="col-md-3">
                                            Variation
                                          </td>
                                          <td className="col-md-3">Qty.</td>
                                          <td className="col-md-3">
                                            Replenish Level
                                          </td>
                                          <td className="col-md-3">
                                            Reorder Level
                                          </td>
                                        </tr>

                                        {itemsDetailsData?.Inventory.map(
                                  (items, index) => {
                                    return (
                                            <tr key={index}>
                                              <td className="col-md-3">
                                                {items?.Variation}
                                              </td>
                                              <td className="col-md-3">
                                                {Number(
                                                  items?.Quantity
                                                ).toFixed(2)}
                                              </td>
                                              <td className="col-md-3">
                                                {Number(
                                                  items?.ReplenishLevel
                                                ).toFixed(2)}
                                              </td>
                                              <td className="col-md-3">
                                                {Number(
                                                  items?.ReorderLevel
                                                ).toFixed(2)}
                                              </td>
                                            </tr>
                                          );
                                        })}


                                     
                               
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab4">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <h4>
                                      <i
                                        class="fa fa-picture-o"
                                        aria-hidden="true"
                                      ></i>
                                      Images
                                    </h4>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {itemsDetailsData?.Images.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-1">
                                          <img
                                            src={items.Name}
                                            alt={items.ID}
                                            width="300"
                                            height="300"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                className="btn btn-sm btn-outline-dark me-1 form-control text-align-center"
                data-bs-dismiss="modal"
              >
                Close
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemsDetailsModal;
